// extracted by mini-css-extract-plugin
export default {"subtitle":"subtitle_subtitle__pZinm"};